import { useQuery } from "./useApi";
import { approvalRequests, type ApprovalRequestsFilters } from "../api/approvalRequests.service";

export function useApprovalRequests(filters?: ApprovalRequestsFilters) {
  return useQuery(
    () => approvalRequests.getAll(filters),
    [
      filters?.limit,
      filters?.offset,
      filters?.publicationId,
      filters?.regionId,
      filters?.practiceAreaId,
      filters?.tableId,
      filters?.edition,
      filters?.firmRef,
      filters?.langInput,
      filters?.langOutput,
      filters?.status,
      filters?.contentType,
      filters?.sentiment,
      filters?.onlyUnlocked,
      filters?.onlyBookers,
      filters?.lawyerName,
      filters?.search,
    ],
  );
}
